import React, { useState, useEffect } from 'react';
import RelevanceScore from '../../../HtmlElements/RelevanceScore';

function NudgeCard({ handleCheckboxChange, handleMore, nudgeData, index, selectedItems }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  // Entry animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, index * 50); // Staggered delay based on index
    return () => clearTimeout(timer);
  }, [index]);

  // Animation styles calculated inline
  const getAnimationStyles = () => {
    const baseStyle = {
      transition: `
        opacity 0.3s ease-out,
        transform 0.3s ease-out,
        box-shadow 0.2s ease-out
      `,
      opacity: isVisible ? 1 : 0,
      transform: `
        translateY(${isVisible ? 0 : '20px'})
        scale(${isPressed ? 0.98 : 1})
        translateY(${isHovered ? '-5px' : '0'})
      `,
      boxShadow: isHovered ? '0 5px 15px rgba(0,0,0,0.1)' : '0 2px 5px rgba(0,0,0,0.05)'
    };

    return baseStyle;
  };

  // Highlight icon animation
  const getHighlightStyles = () => {
    return {
      transition: 'transform 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
      transform: nudgeData?.nudge?.impact_score >= 8 ? 'scale(1)' : 'scale(0)',
      transformOrigin: 'center center'
    };
  };

  return (
    <div className="col-md-6" key={index} >
      <div
        className={`nudges_subblock ${nudgeData?.nudge?.impact_score >= 8 ? "custom_active" : ""}`}
        style={getAnimationStyles()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
      >
        <div className="checkbox_block">
          <input
          className="generic-checkbox-input"
            type="checkbox"
            id={`checkbox-${nudgeData?.opportunity_id}`}
            aria-label="option 1"
            onChange={() => handleCheckboxChange(nudgeData?.opportunity_id)}
            checked={selectedItems.includes(nudgeData?.opportunity_id)}
          />
          <label htmlFor={`checkbox-${nudgeData?.opportunity_id}`}></label>
        </div>

        <div className="content_ndges"                   
         onClick={() => handleMore(nudgeData)} >
          <div className="content_para">
            <div className="content_nudges_para">
              {nudgeData?.nudge.event && (
                <h5
                  className="content_main_head"
                  style={{
                    cursor: 'pointer',
                    transition: 'color 0.2s ease',
                    // color: isHovered ? '#0066cc' : 'inherit'
                  }}
                >
                  {nudgeData?.nudge.event}
                </h5>
              )}
              <div className="nudges_para_custom">
                {nudgeData?.nudge.potential_impact}
              </div>
              <div className="date_company_impact_block">
                <div className="impact_company_block">
                  <div className="impact_score">
                    {nudgeData?.nudge.impact_score && (
                      <RelevanceScore
                        relevanceScore={nudgeData?.nudge.impact_score}
                        section="impact_score"
                      />
                    )}
                  </div>
                </div>
                {nudgeData?.nudge.event_date && (
                  <span className="date_italic">
                    {nudgeData?.nudge.event_date
                      ? new Date(nudgeData?.nudge.event_date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : ""}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {nudgeData?.nudge.impact_score >= 8 && (
          <div className="contet_head_img" style={getHighlightStyles()}>
            <img
              src="/img/icons/trending-up_backcolor.png"
              alt="image"
              className="image_block"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default NudgeCard;